import React, { useState, useEffect } from 'react';
import { apiFetch, getRole } from './api';

function SystemAdminScreen({ onBack }) {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', password: '', role: 'USER' });
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({ password: '', role: 'USER' });
  const role = getRole();

  const generateRandomPassword = () => {
    return Math.random().toString(36).slice(-10) + Math.random().toString(36).slice(-4).toUpperCase();
  };

  useEffect(() => {
    fetchUsers();
    setNewUser({ username: '', password: generateRandomPassword(), role: 'USER' });
  }, []);

  const fetchUsers = async () => {
    const res = await apiFetch('/api/auth/users');
    if (res.ok) {
      setUsers(await res.json());
    }
  };

  const handleCreate = async () => {
    const res = await apiFetch('/api/auth/users', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(newUser)
    });
    if (res.ok) {
      fetchUsers();
      setNewUser({ username: '', password: generateRandomPassword(), role: 'USER' });
    } else {
      alert("Failed to create user");
    }
  };

  const handleStatus = async (u) => {
    if (u.role === 'SUPERADMIN') return;
    const res = await apiFetch(`/api/auth/users/${u.id}/status`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ is_active: !u.is_active })
    });
    if (res.ok) fetchUsers();
    else alert("Failed to change status");
  };

  const startEdit = (u) => {
    setEditingUser(u.id);
    setEditForm({ password: generateRandomPassword(), role: u.role });
  };

  const cancelEdit = () => {
    setEditingUser(null);
  };

  const saveEdit = async (u) => {
    let success = true;
    if (editForm.password.trim() !== '') {
      const resPw = await apiFetch(`/api/auth/users/${u.id}/password`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ new_password: editForm.password })
      });
      if (!resPw.ok) success = false;
    }
    
    if (editForm.role !== u.role) {
      const resRole = await apiFetch(`/api/auth/users/${u.id}/role`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ new_role: editForm.role })
      });
      if (!resRole.ok) success = false;
    }
    
    if (success) {
      setEditingUser(null);
      fetchUsers();
    } else {
      alert("Failed to save some changes.");
    }
  };

  return (
    <div className="admin-screen" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto', color: 'white' }}>
      <button onClick={onBack} style={{ marginBottom: '20px', padding: '10px' }}>&larr; Back to Dashboard</button>
      <h2>System Users Management</h2>
      
      <div className="card" style={{ marginBottom: '40px' }}>
        <h3>Create New System User</h3>
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <input type="text" placeholder="Username" value={newUser.username} onChange={e => setNewUser({...newUser, username: e.target.value})} style={{padding: '10px', borderRadius: '4px', border: '1px solid #444', background: '#222', color: 'white'}} />
          <input type="text" placeholder="Password" value={newUser.password} onChange={e => setNewUser({...newUser, password: e.target.value})} style={{padding: '10px', borderRadius: '4px', border: '1px solid #444', background: '#222', color: 'white'}} />
          <select value={newUser.role} onChange={e => setNewUser({...newUser, role: e.target.value})} style={{padding: '10px', borderRadius: '4px', border: '1px solid #444', background: '#222', color: 'white'}}>
            <option value="USER">Study Center (User)</option>
            <option value="ADMIN">Sponsor (Admin)</option>
            {role === 'SUPERADMIN' && <option value="SUPERADMIN">Superadmin</option>}
          </select>
          <button className="btn-secondary" onClick={handleCreate}>Create</button>
        </div>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#1e1e1e', borderRadius: '8px' }}>
        <thead>
          <tr style={{ backgroundColor: '#333', textAlign: 'left' }}>
            <th style={{ padding: '15px' }}>ID</th>
            <th style={{ padding: '15px' }}>Username</th>
            <th style={{ padding: '15px' }}>Role</th>
            <th style={{ padding: '15px' }}>Status</th>
            <th style={{ padding: '15px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map(u => (
            <React.Fragment key={u.id}>
            <tr style={{ borderBottom: editingUser === u.id ? 'none' : '1px solid #333' }}>
              <td style={{ padding: '15px' }}>{u.id}</td>
              <td style={{ padding: '15px' }}>{u.username}</td>
              <td style={{ padding: '15px' }}>{u.role}</td>
              <td style={{ padding: '15px' }}>{u.is_active ? 'Active' : 'Inactive'}</td>
              <td style={{ padding: '15px', display: 'flex', gap: '10px' }}>
                <button 
                  onClick={() => handleStatus(u)}
                  disabled={u.role === 'SUPERADMIN'}
                  style={{ background: u.role === 'SUPERADMIN' ? '#666' : (u.is_active ? '#fa5252' : '#40c057'), color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: u.role === 'SUPERADMIN' ? 'not-allowed' : 'pointer' }}
                >
                  {u.is_active ? 'Deactivate' : 'Activate'}
                </button>
                {!(role === 'ADMIN' && u.role === 'SUPERADMIN') && (
                  <button onClick={() => startEdit(u)} style={{ background: '#339af0', color: 'white', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' }}>Edit</button>
                )}
              </td>
            </tr>
            {editingUser === u.id && (
              <tr style={{ borderBottom: '1px solid #333', backgroundColor: '#2a2a2a' }}>
                <td colSpan="5" style={{ padding: '15px' }}>
                  <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <strong>Edit {u.username}:</strong>
                    <input type="text" placeholder="New Password" value={editForm.password} onChange={e => setEditForm({...editForm, password: e.target.value})} style={{padding: '8px', borderRadius: '4px', border: '1px solid #444', background: '#111', color: 'white'}} />
                    <select value={editForm.role} onChange={e => setEditForm({...editForm, role: e.target.value})} style={{padding: '8px', borderRadius: '4px', border: '1px solid #444', background: '#111', color: 'white'}}>
                      <option value="USER">Study Center (User)</option>
                      <option value="ADMIN">Sponsor (Admin)</option>
                      {role === 'SUPERADMIN' && <option value="SUPERADMIN">Superadmin</option>}
                    </select>
                    <button onClick={() => saveEdit(u)} style={{ background: '#40c057', color: 'white', border: 'none', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer' }}>Save</button>
                    <button onClick={cancelEdit} style={{ background: 'transparent', color: '#888', border: '1px solid #444', padding: '8px 12px', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
                  </div>
                </td>
              </tr>
            )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SystemAdminScreen;
